/**
 * 国际化 · 中文
 * ------------------------------------------------------------
 * M0 只覆盖壳层固定文案：导航 / 底栏 / 全局搜索 / Portal 头部 / 主题切换。
 * 业务内容（对话、架构、异常…）暂保持中文，等产品确认后再补。
 */
export const zhCN = {
  nav: {
    chat: '聊天',
    messenger: '讨论群',
    task: '任务',
    sched: '日程',
    files: '空间',
    mine: '我的',
    cloudpc: '云电脑',
    apps: '应用',
    arch: '架构',
    appsShort: '应用',
    sol: '产研',
    fde: 'FDE',
    newChat: '新建会话'
  },
  search: {
    placeholder: '搜索应用 / 编码 / 业务对象…',
    prefixHint: '输入 / 后可按类型筛选'
  },
  theme: {
    light: '亮色',
    dark: '暗色',
    toggle: '切换主题'
  },
  language: {
    zh: '中文',
    en: 'English'
  },
  common: {
    back: '返回',
    home: '首页',
    close: '关闭',
    confirm: '确定',
    cancel: '取消',
    loading: '加载中…',
    empty: '暂无数据',
    more: '加载更多'
  },
  org: {
    title: '数据域',
    scope: '可用范围',
    role: '我的角色',
    perm: '执行权限',
    legal: '法人主体',
    period: '会计期间',
    fresh: '新接入企业'
  },
  onb: {
    title: '欢迎接入 EMA',
    step1Title: '核对授权范围',
    step1Desc: '确认当前数据域的可用应用与执行权限',
    step2Title: '浏览架构资产',
    step2Desc: '先了解已接入的业务与应用架构全貌',
    step3Title: '接入业务系统',
    step3Desc: '后续接入业务系统后，异常与任务数据将自动出现',
    start: '开始体验',
    arch: '先看架构总览'
  },
  footer: {
    shortcut: 'Enter 发送 · Shift+Enter 换行'
  }
}
export type Dict = typeof zhCN
